export class Socialusers {
  provider!: string;
  id!: string;
  email!: string;
  name!: string;
  image!: string;
  token?: string;
  idToken?: string;
  user_phone:number;
}
